import React, { createContext, useState, useContext, useLayoutEffect, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        if (typeof window !== 'undefined' && window.themeManager && window.themeManager.getCurrentTheme) {
            return window.themeManager.getCurrentTheme();
        }
        return localStorage.getItem('theme') || 'light';
    });

    // Sync theme with DOM
    useLayoutEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    // Sync with themeManager and listen for changes
    useEffect(() => {
        let intervalId;

        const syncWithThemeManager = () => {
            if (window.themeManager && window.themeManager.getCurrentTheme) {
                const currentTheme = window.themeManager.getCurrentTheme();
                if (currentTheme !== theme) {
                    setTheme(currentTheme);
                }
            }
        };

        // Check for theme changes periodically (every 100ms)
        intervalId = setInterval(syncWithThemeManager, 100);

        // Also listen for storage changes
        const handleStorageChange = (e) => {
            if (e.key === 'theme') {
                syncWithThemeManager();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [theme]);

    const toggleTheme = () => {
        if (window.themeManager && window.themeManager.switchToManualMode) {
            const newTheme = theme === 'light' ? 'dark' : 'light';
            window.themeManager.switchToManualMode(newTheme);
        } else {
            setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};